import { useMutation, useQueryClient } from '@tanstack/react-query'
import { useContext, ChangeEvent, useEffect } from 'react'
import { useInView } from 'react-intersection-observer'
import { useParams } from 'react-router-dom'
import { SellersContext } from '../../../../../../app/contexts/SellerContex'
import { teamsService } from '../../../../../../app/services/teamsService'
import { UpdateTeamdata } from '../../../../../../app/services/teamsService/updateTeam'
import { useToast } from '../../../../../components/ui/use-toast'

type useAddManagerProps = {
  _id: string
  name: string
  profileImageUrl: string
}

export const useAddManagerController = () => {
  const { id } = useParams()
  const { ref, inView } = useInView()
  const queryClient = useQueryClient()

  const { sellers, setSearchValue, searchValue } = useContext(SellersContext)

  const { data, fetchNextPage, hasNextPage, isFetching, isFetchingNextPage } =
    sellers
  const { toast } = useToast()

  const handleSearchInputChange = (event: ChangeEvent<HTMLInputElement>) => {
    setSearchValue(event.target.value)
  }

  useEffect(() => {
    if (inView) {
      fetchNextPage()
    }
  }, [fetchNextPage, inView])

  const { mutateAsync, isPending } = useMutation({
    mutationKey: ['AddMember'],
    mutationFn: async ({
      teamId,
      memberId,
    }: {
      teamId: string
      memberId: UpdateTeamdata
    }) => await teamsService.updateTeam(memberId, teamId),
    onSuccess() {
      queryClient.invalidateQueries({
        queryKey: ['teamId', id],
      })
    },
  })

  const handleUpdateManager = async (user: useAddManagerProps) => {
    try {
      if (user) {
        await mutateAsync({
          teamId: id!,
          memberId: { manager_id: user._id },
        })

        toast({
          title: 'Gerente atualizado com sucesso.',
        })
      }
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error: any) {
      console.log(error)
      toast({
        variant: 'destructive',
        title:
          error.message ||
          'Erro ao atualizar o gerente, tente novamente mais tarde',
      })
    }
  }

  return {
    data,
    isFetching,
    searchValue,
    handleSearchInputChange,
    fetchNextPage,
    hasNextPage,
    isFetchingNextPage,
    ref,
    handleUpdateManager,
    isPending,
  }
}
